import { render, staticRenderFns } from "./CertificateDetail.vue?vue&type=template&id=0ded89b3&"
import script from "./CertificateDetail.vue?vue&type=script&lang=ts&"
export * from "./CertificateDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports